import store from 'app/store/AppStore';

import {gt} from 'app/utils/i18n';

import {showToastNotification} from '../../../toasts/slice';
import {
  basicAccountOwnerUserDataSource,
  basicUserDataSource,
} from '../../demo_fixtures';
import {nowISOString, waitAndReturn} from '../../utils';

export const ACCEPTANCE_RTK_TAGS = {
  TAGS: 'acceptance',
  VERSION_STATUS_TAG: 'acceptance_version_status',
};

const requestVersionAcceptance = ({message, versionId}) => {
  return {
    unwrap: () => {
      store.dispatch(
        showToastNotification(
          gt('An approval request was sent to the selected managers.')
        )
      );
      return waitAndReturn({
        id: 1,
        url: '/api/v1/acceptance/1/',
        object_id: versionId,
        content_type: 'procedureversion',
        accept_statuses: [
          {
            id: 14785,
            url: '/acceptancestatus/1/',
            user: basicAccountOwnerUserDataSource,
            status: null,
            accepted_at: null,
            rejected_at: null,
            created_at: nowISOString(),
            modified_at: nowISOString(),
            seen_at: null,
          },
        ],
        message,
        requester: basicUserDataSource,
        created_at: nowISOString(),
        modified_at: nowISOString(),
      });
    },
  };
};

export const useRequestVersionAcceptance = () => [requestVersionAcceptance];
